import { createFileRoute } from "@tanstack/react-router";
import { SubPage } from "@/components/sub-page";

export const Route = createFileRoute("/clientes/casos-exito")({
  head: () => ({
    meta: [
      { title: "Casos de Éxito | Mine Class" },
      { name: "description", content: "Casos de éxito de nuestros clientes en la industria minera." },
      { property: "og:title", content: "Casos de Éxito | Mine Class" },
      { property: "og:description", content: "Historias reales de transformación digital y capacitación con clientes mineros de Mine Class." },
      { property: "og:url", content: "https://mine-class.com/clientes/casos-exito" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/clientes/casos-exito" }],
  }),
  component: Page,
});

function Page() {
  const cases = [
    {
      id: "gerardo-vega",
      src: "https://www.youtube.com/embed/zfx_qlGXgdE?si=BtcfNdJkfavyEWD9",
      title: "YouTube video player",
      name: "Gerardo Vega - Director Corporativo de Gestión y Fiscalización de Empresas Contratistas de CODELCO",
    },
    {
      id: "alvaro-falcon",
      src: "https://www.youtube.com/embed/HyzIa5SK6IY",
      title: "Álvaro Falcón - Ex ejecutivo Anglo American",
      name: "Álvaro Falcón - Ex ejecutivo Anglo American",
    },
  ];

  return (
    <SubPage
      section="clientes"
      eyebrow="Nuestros Clientes"
      title="Casos de éxito"
      intro="Historias reales de transformación digital en la industria minera."
    >
      <div className="grid gap-8 md:gap-10 lg:grid-cols-2">
        {cases.map((item) => (
          <article
            key={item.id}
            className="group overflow-hidden rounded-2xl border-2 border-[var(--color-brand-purple)] bg-[var(--color-brand-purple)]/5 transition-all duration-300 hover:shadow-xl hover:shadow-[var(--color-brand-purple)]/20"
          >
            <div className="aspect-video w-full bg-[var(--color-surface-container-low)]">
              <iframe
                className="h-full w-full"
                src={item.src}
                title={item.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
            <div className="bg-[var(--color-brand-coral)] px-4 py-3 md:px-5 md:py-4">
              <p className="text-sm font-bold uppercase tracking-wide text-white md:text-base">
                {item.name}
              </p>
            </div>
          </article>
        ))}
      </div>
    </SubPage>
  );
}
